import styled from "styled-components";
import {
  Field,
  InputText,
  Type,
} from "discover.medical.react-component-library";

export const StyledMessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.space.md} ${theme.space.md} 0`};
`;

export const StyledFieldsContainer = styled.div`
  padding: 0 ${({ theme }) => `${theme.space.md}`};
`;

export const StyledField = styled(Field)`
  margin-top: ${({ theme }) => `${theme.space.md}`};

  & > label {
    font-size: ${({ theme }) => `${theme.font.size.md}`}!important;
    font-weight: ${({ theme }) => `${theme.font.weight.bold}`}!important;
  }
`;

export const StyledInputText = styled(InputText)`
  input {
    font-size: ${({ theme }) => `${theme.font.size.md}`}!important;
  }
`;

export const StyledTextContainer = styled(Type)`
  display: flex;
  flex-direction: column;
`;
